import { Action, ActionStatus, buildActionType, FailedNotification, NotificationType, SuccessNotification } from '../core';
import { CHECK_USER_MEMBERSHIP } from '../new';
import { BUSY_INDICATOR, DECREASE, INCREASE, NOT_AUTHORIZED, NOTIFICATION } from '../types';

export const silentExecute = async (dispatch, execMethod, actionType) => {
  await execute(dispatch, execMethod, actionType, false, null, true);
};

export const transparentExecute = async (dispatch, execMethod, actionType) => {
  await execute(dispatch, execMethod, actionType, true);
};

export const execute = async (
  dispatch,
  execMethod,
  actionType,
  notification = null,
  requestPayload = null,
  silent = false,
  customMessage = false
) => {
  const entity = actionType.entity;
  const action = actionType.action;
  const actionName = `${entity}${action}`;
  let showNotification = notification;

  if ((action === Action.GET_MANY || action === Action.GET || action === Action.HANDLE) && notification === null) {
    showNotification = false;
  }

  if (showNotification === null) {
    showNotification = true;
  }
  if (requestPayload) {
    dispatch({ type: `${actionName}${ActionStatus.START}`, payload: requestPayload });
  } else {
    if (!silent) {
      dispatch({ type: `${actionName}${ActionStatus.START}` });
    }
  }

  dispatch({ type: INCREASE });
  dispatch({ type: buildActionType(BUSY_INDICATOR, ActionStatus.START) });

  try {
    const payload = await execMethod();

    if (payload.success === false) {
      if (payload.errors?.length) {
        dispatch({ type: `${actionName}${ActionStatus.FAILED}`, payload: payload.errors });
        notify(dispatch, payload.errors[0]?.message || `${FailedNotification[action]}`, NotificationType.Error, showNotification);
      } else {
        throw new Error(payload.message || 'system error');
      }
      return false;
    } else {
      dispatch({ type: `${actionName}${ActionStatus.DONE}`, payload: { payload, request: requestPayload } });
      if (customMessage) {
        generateCustomNotificationMessage(dispatch, actionType, payload);
      } else {
        notify(dispatch, `${SuccessNotification[action]}`, NotificationType.Success, showNotification);
      }
      return true;
    }
  } catch (ex) {
    dispatch({ type: `${actionName}${ActionStatus.FAILED}`, payload: ex.message });
    notify(dispatch, `${FailedNotification[action]}`, NotificationType.Error, showNotification);

    try {
      if (ex.graphQLErrors && ex.graphQLErrors.some(err => err.extensions.code === 'UNAUTHENTICATED')) {
        dispatch({ type: NOT_AUTHORIZED, payload: false });
      }
    } catch (err) {
      // ignore
    }
    return false;
  } finally {
    dispatch({ type: DECREASE });
    dispatch({ type: buildActionType(BUSY_INDICATOR, ActionStatus.DONE) });
  }
};

const notify = (dispatch, message, variant, show) => {
  if (show) {
    dispatch({ type: NOTIFICATION, payload: { message, variant } });
  }
};
//  POSIBLE NEEDED IN FUTURE
const langs = {
  [buildActionType(CHECK_USER_MEMBERSHIP)]: {
    en: {
      available: 'Membership Available',
      notAvailable: 'Membership not available',
    },
    it: {
      available: 'Abbonamento disponibile',
      notAvailable: 'Iscrizione non disponibile',
    },
    de: {
      available: 'Mitgliedschaft verfügbar',
      notAvailable: 'Mitgliedschaft nicht verfügbar',
    },
  },
};

const generateCustomNotificationMessage = (dispatch, actionType, payload) => {
  const lang = localStorage.getItem('i18nextLng') || 'it';
  if (buildActionType(actionType) === buildActionType(CHECK_USER_MEMBERSHIP)) {
    if (payload?.data?.userHasMembership) {
      notify(dispatch, langs[buildActionType(actionType)][lang]['available'], NotificationType.Success, true);
    } else {
      notify(dispatch, langs[buildActionType(actionType)][lang]['notAvailable'], NotificationType.Warning, true);
    }
  }
};
// POSIBLE NEEDED IN FUTURE
